import { format } from "d3-format";
import React, { Component } from "react";
import PropTypes from "prop-types";

import displayValuesFor from "./displayValuesFor";
import GenericChartComponent from "../GenericChartComponent";

import ToolTipText from "./ToolTipText";
import ToolTipTSpanLabel from "./ToolTipTSpanLabel";
import { functor, isDefined } from "../utils";

class VolumeOscillatorTooltip extends Component {
  constructor(props) {
    super(props);
    this.renderSVG = this.renderSVG.bind(this);
  }
  renderSVG(moreProps) {
    const { onClick, fontFamily, fontSize, displayFormat, className } =
      this.props;
    const { yAccessor, options, appearance, labelFill, textFill } = this.props;
    const { displayValuesFor } = this.props;

    const {
      chartConfig: { width, height },
    } = moreProps;

    const currentItem = displayValuesFor(this.props, moreProps);
    const value = currentItem && yAccessor(currentItem);

    const displayValue = (isDefined(value) && displayFormat(value)) || "n/a";

    const { origin: originProp } = this.props;
    const origin = functor(originProp);
    const [x, y] = origin(width, height);

    // Get mode label
    const modeLabel = options.pointsOrPercent === "Percent" ? "%" : "Pts";

    // Get stroke color
    const strokeColor = appearance?.stroke?.color || textFill;

    return (
      <g
        className={className}
        transform={`translate(${x}, ${y})`}
        onClick={onClick}
        data-evo-id="tooltip-volume-oscillator"
      >
        <ToolTipText x={0} y={0} fontFamily={fontFamily} fontSize={fontSize}>
          <ToolTipTSpanLabel fill={labelFill}>Vol Osc (</ToolTipTSpanLabel>
          <tspan fill={strokeColor}>{options.shortCycle}</tspan>
          <ToolTipTSpanLabel fill={labelFill}>, </ToolTipTSpanLabel>
          <tspan fill={strokeColor}>{options.longCycle}</tspan>
          <ToolTipTSpanLabel fill={labelFill}>, </ToolTipTSpanLabel>
          <tspan fill={strokeColor}>{modeLabel}</tspan>
          <ToolTipTSpanLabel fill={labelFill}>): </ToolTipTSpanLabel>
          <tspan fill={strokeColor}>{displayValue}</tspan>
        </ToolTipText>
      </g>
    );
  }
  render() {
    return (
      <GenericChartComponent
        clip={false}
        svgDraw={this.renderSVG}
        drawOn={["mousemove"]}
      />
    );
  }
}

VolumeOscillatorTooltip.propTypes = {
  className: PropTypes.string,
  displayFormat: PropTypes.func.isRequired,
  origin: PropTypes.oneOfType([PropTypes.array, PropTypes.func]).isRequired,
  displayValuesFor: PropTypes.func,
  yAccessor: PropTypes.func.isRequired,
  appearance: PropTypes.shape({
    stroke: PropTypes.shape({
      color: PropTypes.string,
    }),
  }),
  options: PropTypes.shape({
    shortCycle: PropTypes.number.isRequired,
    longCycle: PropTypes.number.isRequired,
    pointsOrPercent: PropTypes.string.isRequired,
  }).isRequired,
  labelFill: PropTypes.string,
  textFill: PropTypes.string,
  fontFamily: PropTypes.string,
  fontSize: PropTypes.number,
  onClick: PropTypes.func,
};

VolumeOscillatorTooltip.defaultProps = {
  className:
    "react-stockcharts-tooltip react-stockcharts-volume-oscillator-tooltip",
  displayFormat: format(".2f"),
  displayValuesFor: displayValuesFor,
  origin: [0, 10],
  labelFill: "#4682B4",
  textFill: "#000000",
};

export default VolumeOscillatorTooltip;
